import Misc from "../../../config";
import {isTouchDevice} from "../../../misc/utils";

export function exportSceneToGLB (scene, shouldReturnURL) {
  const exporter = new window.GLTFExporter();

  return new Promise((resolve, reject) => {
    exporter.parse(
      scene,(result) => {
        //const blob = new Blob([result], { type: 'model/gltf-binary' });
        const blob = new Blob([JSON.stringify(result)], {type: 'text/plain'});
        resolve(shouldReturnURL ? URL.createObjectURL(blob) : blob);
      },
      (error) => reject(error)
    );
  });
}

export async function exportSceneToUSDZ(scene, shouldReturnURL) {
  const exporter = new window.USDZExporter();

  try {
    const arraybuffer = await exporter.parseAsync(scene);
    const blob = new Blob( [ arraybuffer ], { type: 'application/octet-stream' } );

    return shouldReturnURL ? URL.createObjectURL(blob) : blob;
  } catch (error) {
    console.error('Error exporting scene to USDZ:', error);
  }
}

export async function handleDownloadUSDZ (scene) {
  if (!scene) {
    console.error('Scene is not available for export.');
    return;
  }

  try {
    const usdzUrl = await exportSceneToUSDZ(scene);

    // open Quick Look
    const link = Object.assign(document.createElement('a'), {
      download: 'asset.usdz',
      rel: "ar",
      href: usdzUrl,
      textContent: "View in AR"
    });

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Failed to export scene to USDZ:', error);
  }
}

export function blobToBase64 (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]); // Убираем часть "data:..."
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(blob);
  });
}

export function compressMeshForMobileDevices(mesh) {
  if (mesh) {
    let originalMaterial = mesh.material;

    const isMobile = Misc.isMobile() || isTouchDevice();

    if (isMobile) {
      // Resize all texture maps
      ["map", "metalnessMap", "normalMap", "aoMap", "roughnessMap", "displacementMap"].forEach((map) => {
        if (originalMaterial[map]) {
          resizeExistingTexture(originalMaterial[map], 512); //Texture max sizw
          //originalMaterial[map] = this.compressTexture(originalMaterial[map]);
        }
      });

      //Optimize filtering for performance
      if (originalMaterial.map) {
        originalMaterial.map.anisotropy = 1;
        originalMaterial.map.generateMipmaps = false;
        originalMaterial.map.minFilter = window.THREE.LinearFilter;
        originalMaterial.map.magFilter = window.THREE.LinearFilter;
      }

      originalMaterial.needsUpdate = true;
    }
  }
}

export async function resizeExistingTexture(texture, maxSize = 512) {
  const image = texture.image;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // Calculate new size while maintaining aspect ratio
  let width = image.width;
  let height = image.height;
  if (width > maxSize || height > maxSize) {
    if (width > height) {
      height *= maxSize / width;
      width = maxSize;
    } else {
      width *= maxSize / height;
      height = maxSize;
    }
  }

  // Resize the texture using Canvas
  canvas.width = Math.round(width);
  canvas.height = Math.round(height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

  // Create an ImageBitmap to ensure WebGL compatibility
  const imageBitmap = await createImageBitmap(canvas);

  // Replace the original image in the texture
  texture.image = imageBitmap;
  texture.needsUpdate = true;
}

export function compressTexture(texture, quality = 0.9) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const image = texture.image;

  canvas.width = image.width;
  canvas.height = image.height;
  ctx.drawImage(image, 0, 0, image.width, image.height);

  const webpDataUrl = canvas.toDataURL('image/webp', quality);

  const compressedTexture = new THREE.TextureLoader().load(webpDataUrl);
  compressedTexture.needsUpdate = true;

  return compressedTexture;
}
